import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Backdrop from "../../../../../Components/UI/Backdrop/Backdrop";
import StaticInfoCardList from "./components/StaticInfoCardList";
import { RequestStaticInfo } from "../../../../../store/actions/analysisReportActions";
import { prepareStaticInfoDataStaticResultsTab } from "./utils/staticInfoUtil";

import "./styles.scss";

//GET FILE ID IN URL
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const StaticInfo = ({ report = false }) => {
  const dispatch = useDispatch();
  const staticInfoResponse = useSelector((state) => state.analysisReports.staticInfoList);
  const isLoading = useSelector((state) => state.analysisReports.loading);
  const [staticInfoDataList, setStaticInfoDataList] = useState([]);

  const collapseHandler = (title, subTitle) => {
    setStaticInfoDataList((prevState) =>
      prevState.map((cardData) => {
        if (cardData["title"] === title) {
          return {
            ...cardData,
            items: cardData["items"].map((cardDataItem) => {
              if (cardDataItem["subTitle"] === subTitle) {
                return {
                  ...cardDataItem,
                  collapsed: !cardDataItem["collapsed"],
                };
              }
              return cardDataItem;
            }),
          };
        }
        return cardData;
      }),
    );
  };

  //SET QUERY FOR GETTING DATA ID
  let query = useQuery();
  const originalId = query.get("data");

  useEffect(() => {
    dispatch(RequestStaticInfo(originalId));
  }, [dispatch, originalId]);

  useEffect(() => {
    if (staticInfoResponse.length !== 0) {
      const subCategories = { ...staticInfoResponse.target.file, trid: staticInfoResponse.trid };
      const subCategoryFields = Object.keys(subCategories);

      const staticInfoData = prepareStaticInfoDataStaticResultsTab(
        subCategoryFields,
        subCategories,
      );
      // Cards come back collapsed; on paper there is nothing to click, so the
      // report and the pdf show everything expanded
      setStaticInfoDataList(
        report
          ? staticInfoData.map((cardData) => ({
              ...cardData,
              items: cardData.items.map((item) =>
                item?.subTitle ? { ...item, collapsed: false } : item,
              ),
            }))
          : staticInfoData,
      );
    }
  }, [staticInfoResponse, report]);

  // state.analysisReports.loading is shared with a dozen other requests, so in
  // report mode it must not gate the content: the pdf is captured on a timer
  // and would otherwise catch an empty section.
  if (report) {
    return (
      <div className="static-info-container">
        <StaticInfoCardList
          staticInfoDataList={staticInfoDataList}
          onCollapseSubTitle={collapseHandler}
        />
      </div>
    );
  }

  return (
    <div className="static-info-container">
      <Backdrop show={isLoading} absolute={true} />
      {!isLoading && staticInfoDataList && (
        <StaticInfoCardList
          staticInfoDataList={staticInfoDataList}
          onCollapseSubTitle={collapseHandler}
        />
      )}
    </div>
  );
};

export default StaticInfo;
